/* eslint-disable */
/* tslint:disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AccountDetails = {
  __typename?: 'AccountDetails';
  features: Array<Features>;
};

export enum AccountSource {
  Coinbase = 'coinbase',
  Manual = 'manual',
  Plaid = 'plaid'
}

export enum ActionType {
  Add = 'add',
  Remove = 'remove',
  Update = 'update'
}

export type AlphaUser = {
  __typename?: 'AlphaUser';
  email?: Maybe<Scalars['String']>;
  status?: Maybe<AlphaUserType>;
};

export enum AlphaUserType {
  Approved = 'approved',
  Pending = 'pending'
}

export type Client = {
  __typename?: 'Client';
  id: Scalars['String'];
};

export type ClientMessage = {
  __typename?: 'ClientMessage';
  data: Scalars['JSON'];
  destination: Array<Scalars['ID']>;
  source: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export enum CollectionType {
  Collection = 'collection',
  DataObject = 'data_object',
  Item = 'item'
}

export type DataCollection = {
  __typename?: 'DataCollection';
  collections?: Maybe<Array<DataCollectionData>>;
  entries?: Maybe<Array<DataEntry>>;
  objects?: Maybe<Array<DataObject>>;
  root?: Maybe<DataCollectionData>;
};

export type DataCollectionData = {
  __typename?: 'DataCollectionData';
  active?: Maybe<Scalars['Boolean']>;
  collectionUuids: Array<Scalars['ID']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  entryUuids: Array<Scalars['ID']>;
  name: Scalars['String'];
  objectUuids: Array<Scalars['ID']>;
  ordinal: Scalars['Int'];
  ownerUuid: Scalars['ID'];
  parent?: Maybe<Array<DataParent>>;
  uuid: Scalars['ID'];
};

export type DataCollectionInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<UpdateItemInput>>;
  name?: InputMaybe<Scalars['String']>;
  ordinal: Scalars['Int'];
  uuid?: InputMaybe<Scalars['ID']>;
};

export type DataCollectionOrderInput = {
  items: Array<UpdateItemOrderInput>;
};

export type DataEntry = {
  __typename?: 'DataEntry';
  active?: Maybe<Scalars['Boolean']>;
  createdByUuid?: Maybe<Scalars['ID']>;
  data: Array<DataEntryData>;
  dataUuid: Scalars['ID'];
  dateCompleted?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateDue?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  hideFields?: Maybe<Array<Scalars['String']>>;
  instances: Array<DataEntryInstance>;
  objectUuid: Scalars['ID'];
  ownerUuid: Scalars['ID'];
  parent?: Maybe<Array<DataParent>>;
  title: Scalars['String'];
};

export type DataEntryData = {
  __typename?: 'DataEntryData';
  customName?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  entryUuid: Scalars['ID'];
};

export type DataEntryDataInput = {
  customName?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  entryUuid: Scalars['ID'];
};

export type DataEntryInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  data?: InputMaybe<Array<DataEntryDataInput>>;
  dataParent?: InputMaybe<Array<UpdateItemInput>>;
  dataUuid?: InputMaybe<Scalars['ID']>;
  dateCompleted?: InputMaybe<NullableDateTimeInput>;
  dateDue?: InputMaybe<NullableDateTimeInput>;
  description?: InputMaybe<Scalars['String']>;
  objectUuid: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type DataEntryInstance = {
  __typename?: 'DataEntryInstance';
  active?: Maybe<Scalars['Boolean']>;
  dateCompleted?: Maybe<Scalars['DateTime']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateDue?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  instanceData: Array<DataEntryData>;
  instanceUuid: Scalars['ID'];
  objectUuid?: Maybe<Scalars['ID']>;
};

export type DataEntryInstanceInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  data: Array<DataEntryDataInput>;
  dataInstanceUuid?: InputMaybe<Scalars['ID']>;
  dataUuid?: InputMaybe<Scalars['ID']>;
  dateCompleted?: InputMaybe<NullableDateTimeInput>;
  dateDue?: InputMaybe<NullableDateTimeInput>;
  objectUuid: Scalars['ID'];
};

export enum DataEntryType {
  Boolean = 'boolean',
  DataObject = 'data_object',
  Date = 'date',
  Enum = 'enum',
  Formula = 'formula',
  Image = 'image',
  Integer = 'integer',
  Link = 'link',
  Number = 'number',
  String = 'string'
}

export type DataEntryUpdateInput = {
  action: ActionType;
  dataEntry: DataEntryInput;
};

export type DataObject = {
  __typename?: 'DataObject';
  active?: Maybe<Scalars['Boolean']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  entries?: Maybe<Array<DataObjectEntry>>;
  hideFields?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  ownerUuid: Scalars['ID'];
  parent?: Maybe<Array<DataParent>>;
  templateUuid?: Maybe<Scalars['ID']>;
  uuid: Scalars['ID'];
};

export type DataObjectEntry = {
  __typename?: 'DataObjectEntry';
  active?: Maybe<Scalars['Boolean']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  objectUuid: Scalars['ID'];
  ordinal: Scalars['Int'];
  schema?: Maybe<Scalars['JSON']>;
  type: DataEntryType;
  uuid: Scalars['ID'];
};

export type DataObjectEntryInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  objectUuid: Scalars['ID'];
  ordinal: Scalars['Int'];
  schema?: InputMaybe<Scalars['JSON']>;
  type: DataEntryType;
  uuid?: InputMaybe<Scalars['ID']>;
};

export type DataObjectInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  entries?: InputMaybe<Array<DataObjectEntryInput>>;
  name: Scalars['String'];
  ownerUuid?: InputMaybe<Scalars['ID']>;
  templateUuid?: InputMaybe<Scalars['ID']>;
  uuid?: InputMaybe<Scalars['ID']>;
};

export type DataPage = {
  __typename?: 'DataPage';
  active?: Maybe<Scalars['Boolean']>;
  data: Array<DataPageData>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerUuid: Scalars['ID'];
  uuid: Scalars['ID'];
};

export type DataPageData = {
  __typename?: 'DataPageData';
  itemUuid: Scalars['ID'];
  type: CollectionType;
  uuid: Scalars['ID'];
};

export type DataPageInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<UpdateItemInput>>;
  name: Scalars['String'];
  uuid: Scalars['ID'];
};

export type DataParent = {
  __typename?: 'DataParent';
  childUuid?: Maybe<Scalars['ID']>;
  ordinal: Scalars['Int'];
  type: CollectionType;
  uuid: Scalars['ID'];
};

export enum Features {
  PdfParser = 'pdfParser',
  Qr = 'qr',
  Stock = 'stock',
  StockImport = 'stockImport'
}

export type FeedbackInput = {
  message?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FeedbackType>;
};

export enum FeedbackType {
  FeatureRequest = 'feature_request',
  Issue = 'issue',
  Suggestion = 'suggestion'
}

export enum FetchDestination {
  Bearer = 'bearer',
  Cookie = 'cookie',
  Fidelity = 'fidelity',
  Pdf = 'pdf',
  Robinhood = 'robinhood'
}

export type File = {
  __typename?: 'File';
  expiration?: Maybe<Scalars['DateTime']>;
  filename: Scalars['String'];
  url: Scalars['String'];
  uuid: Scalars['ID'];
};

export type Friend = {
  __typename?: 'Friend';
  dateConfirmed?: Maybe<Scalars['DateTime']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  status?: Maybe<FriendStatus>;
  user: User;
};

export type FriendInput = {
  friendUuid: Scalars['ID'];
  shadowUser?: InputMaybe<ShadowUserInput>;
  status: FriendStatus;
};

export enum FriendStatus {
  Confirmed = 'confirmed',
  Pending = 'pending',
  Shadow = 'shadow'
}

export enum HistoryFrequency {
  Annually = 'annually',
  Daily = 'daily',
  Hour1 = 'hour1',
  Min5 = 'min5',
  Min15 = 'min15',
  Min30 = 'min30',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export type Launch = {
  __typename?: 'Launch';
  id: Scalars['ID'];
  isBooked: Scalars['Boolean'];
  mission?: Maybe<Mission>;
  rocket?: Maybe<Rocket>;
  site?: Maybe<Scalars['String']>;
};

export type Message = {
  __typename?: 'Message';
  data?: Maybe<MockData>;
  dateAdded?: Maybe<Scalars['DateTime']>;
};

export type Mission = {
  __typename?: 'Mission';
  missionPatch?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type MissionMissionPatchArgs = {
  size?: InputMaybe<PatchSize>;
};

export type MockData = {
  __typename?: 'MockData';
  data: Scalars['JSON'];
  entryUuid: Scalars['ID'];
  name: Scalars['String'];
  userUuid: Scalars['ID'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addDataCollection: DataCollectionData;
  addDataEntry: DataEntry;
  addDataObject: DataObject;
  addDataPage: DataPage;
  addFriend: Friend;
  addMockData: MockData;
  addPlaidLinkedInstitution: PlaidLinkedInstitution;
  bookTrips: TripUpdateResponse;
  cancelTrip: TripUpdateResponse;
  confirmFriend: Friend;
  deleteDataCollection: DataCollectionData;
  deleteDataEntry: DataEntry;
  deleteDataObject: DataObject;
  deleteDataPage: DataPage;
  deleteFiles: Array<File>;
  deleteFriend: Friend;
  deletePlaidLinkedInstitution: PlaidLinkedInstitution;
  postPlaidLinkToken: PlaidLinkToken;
  registerAlphaUser?: Maybe<AlphaUser>;
  registerUser?: Maybe<User>;
  sendToClient: Array<Scalars['String']>;
  submitFeedback?: Maybe<Scalars['Boolean']>;
  updateDataCollection: DataCollectionData;
  updateDataCollectionOrder: DataCollection;
  updateDataEntries: Array<DataEntry>;
  updateDataEntry: DataEntry;
  updateDataObject: DataObject;
  updateDataObjectEntries: DataObject;
  updateDataPage: DataPage;
  updateMockData: MockData;
  updatePlaidLinkedInstitution: PlaidLinkedInstitution;
};


export type MutationAddDataCollectionArgs = {
  dataCollection: DataCollectionInput;
};


export type MutationAddDataEntryArgs = {
  dataEntry: DataEntryInput;
};


export type MutationAddDataObjectArgs = {
  dataObject: DataObjectInput;
};


export type MutationAddDataPageArgs = {
  dataPage: DataPageInput;
};


export type MutationAddFriendArgs = {
  user: FriendInput;
};


export type MutationAddMockDataArgs = {
  data: Scalars['JSON'];
  name: Scalars['String'];
};


export type MutationAddPlaidLinkedInstitutionArgs = {
  institution: PlaidLinkedInstitutionInput;
};


export type MutationBookTripsArgs = {
  launchIds: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationCancelTripArgs = {
  launchId: Scalars['ID'];
};


export type MutationConfirmFriendArgs = {
  userUuid: Scalars['String'];
};


export type MutationDeleteDataCollectionArgs = {
  collectionUuid: Scalars['ID'];
};


export type MutationDeleteDataEntryArgs = {
  dataUuid: Scalars['ID'];
  objectUuid: Scalars['ID'];
};


export type MutationDeleteDataObjectArgs = {
  uuid: Scalars['ID'];
};


export type MutationDeleteDataPageArgs = {
  pageUuid: Scalars['ID'];
};


export type MutationDeleteFilesArgs = {
  uuids: Array<Scalars['ID']>;
};


export type MutationDeleteFriendArgs = {
  uuid: Scalars['String'];
};


export type MutationDeletePlaidLinkedInstitutionArgs = {
  accounts?: InputMaybe<Array<InputMaybe<PlaidAccountInput>>>;
  linkedId: Scalars['String'];
};


export type MutationPostPlaidLinkTokenArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
};


export type MutationRegisterAlphaUserArgs = {
  user: UserInput;
};


export type MutationRegisterUserArgs = {
  user: UserInput;
};


export type MutationSendToClientArgs = {
  data: Scalars['JSON'];
  destination: Array<Scalars['ID']>;
  source: Scalars['ID'];
};


export type MutationSubmitFeedbackArgs = {
  feedback?: InputMaybe<FeedbackInput>;
};


export type MutationUpdateDataCollectionArgs = {
  dataCollection: DataCollectionInput;
};


export type MutationUpdateDataCollectionOrderArgs = {
  dataCollection: DataCollectionOrderInput;
};


export type MutationUpdateDataEntriesArgs = {
  dataEntries: Array<DataEntryUpdateInput>;
};


export type MutationUpdateDataEntryArgs = {
  dataEntry: DataEntryInput;
};


export type MutationUpdateDataObjectArgs = {
  dataObject: DataObjectInput;
};


export type MutationUpdateDataObjectEntriesArgs = {
  dataObject: DataObjectInput;
};


export type MutationUpdateDataPageArgs = {
  dataPage: DataPageInput;
};


export type MutationUpdateMockDataArgs = {
  data: Scalars['JSON'];
  entryUuid: Scalars['String'];
  name: Scalars['String'];
};


export type MutationUpdatePlaidLinkedInstitutionArgs = {
  institution: PlaidLinkedInstitutionInput;
};

export type NullableDateTimeInput = {
  date?: InputMaybe<Scalars['DateTime']>;
};

export enum PatchSize {
  Large = 'LARGE',
  Small = 'SMALL'
}

export type PlaidAccessToken = {
  __typename?: 'PlaidAccessToken';
  accessToken: Scalars['String'];
  itemId: Scalars['String'];
  requestId: Scalars['String'];
};

export type PlaidAccount = {
  __typename?: 'PlaidAccount';
  accountId: Scalars['String'];
  balances: PlaidAccountBalance;
  brokerAccountId?: Maybe<Scalars['String']>;
  lastFour?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subtype?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type PlaidAccountBalance = {
  __typename?: 'PlaidAccountBalance';
  available?: Maybe<Scalars['Float']>;
  current?: Maybe<Scalars['Float']>;
};

export type PlaidAccountInput = {
  accountId?: InputMaybe<Scalars['String']>;
  accountName: Scalars['String'];
  bankId?: InputMaybe<Scalars['String']>;
  bankName: Scalars['String'];
  brokerAccountId?: InputMaybe<Scalars['String']>;
  lastFour?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type PlaidHolding = {
  __typename?: 'PlaidHolding';
  accountId?: Maybe<Scalars['String']>;
  costBasis?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceDate?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  securityId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type PlaidHoldings = {
  __typename?: 'PlaidHoldings';
  accounts: Array<PlaidAccount>;
  holdings: Array<PlaidHolding>;
  securities: Array<PlaidSecurity>;
};

export type PlaidInvestment = {
  __typename?: 'PlaidInvestment';
  accounts: Array<PlaidAccount>;
  securities: Array<PlaidSecurity>;
  transactions: Array<PlaidInvestmentTransaction>;
};

export type PlaidInvestmentTransaction = {
  __typename?: 'PlaidInvestmentTransaction';
  accountId: Scalars['String'];
  amount?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['String']>;
  fees?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  securityId?: Maybe<Scalars['String']>;
  subtype?: Maybe<Scalars['String']>;
  transactionId: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type PlaidLinkToken = {
  __typename?: 'PlaidLinkToken';
  expiration: Scalars['DateTime'];
  linkToken: Scalars['String'];
  requestId: Scalars['String'];
};

export type PlaidLinkedInstitution = {
  __typename?: 'PlaidLinkedInstitution';
  accounts: Array<PlaidAccount>;
  institutionId: Scalars['String'];
  institutionName: Scalars['String'];
  linkedId: Scalars['String'];
  source?: Maybe<Scalars['String']>;
};

export type PlaidLinkedInstitutionInput = {
  accounts: Array<PlaidAccountInput>;
  institutionId?: InputMaybe<Scalars['String']>;
  institutionName: Scalars['String'];
  linkedId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type PlaidSecurity = {
  __typename?: 'PlaidSecurity';
  closePrice?: Maybe<Scalars['Float']>;
  closePriceDate?: Maybe<Scalars['String']>;
  cusip?: Maybe<Scalars['String']>;
  isin?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  securityId: Scalars['String'];
  sedol?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PlaidTransaction = {
  __typename?: 'PlaidTransaction';
  accountId: Scalars['String'];
  amount?: Maybe<Scalars['Float']>;
  category: Array<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  merchantName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  transactionId: Scalars['String'];
  transactionType?: Maybe<Scalars['String']>;
};

export type PlaidTransactions = {
  __typename?: 'PlaidTransactions';
  accounts: Array<PlaidAccount>;
  transactions: Array<PlaidTransaction>;
  value: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  getAllMockData: Array<MockData>;
  getAllStocks: Array<Maybe<StockPrice>>;
  getCoinbaseData: Scalars['String'];
  getDataCollections: Array<DataCollectionData>;
  getDataCollectionsById: DataCollection;
  getDataEntries: Array<DataEntry>;
  getDataObjects: Array<DataObject>;
  getDataPage: DataPage;
  getDataPages: Array<DataPage>;
  getFetch: Scalars['String'];
  getFiles: Array<File>;
  getFriends: Array<Friend>;
  getMockData: MockData;
  getPlaidAccessToken: PlaidLinkedInstitution;
  getPlaidAccounts: Array<PlaidAccount>;
  getPlaidHoldings: PlaidHoldings;
  getPlaidInvestmentTransactions: PlaidInvestment;
  getPlaidLinkedInstitutions: Array<PlaidLinkedInstitution>;
  getPlaidReauth: PlaidLinkedInstitution;
  getPlaidTransactions: PlaidTransactions;
  getRefreshedFiles: Array<File>;
  getStock: StockPrice;
  getStockDetails: StockDetails;
  getStockHistory: Array<StockHistoryPrice>;
  getStockSearch: Array<StockResult>;
  getStocks: Array<StockPrice>;
  getUser: User;
  launch?: Maybe<Launch>;
  launches: Array<Maybe<Launch>>;
  me?: Maybe<User>;
  ping: Scalars['String'];
};


export type QueryGetCoinbaseDataArgs = {
  account?: InputMaybe<Scalars['String']>;
  dataType: Scalars['String'];
};


export type QueryGetDataCollectionsByIdArgs = {
  uuids: Array<Scalars['ID']>;
};


export type QueryGetDataEntriesArgs = {
  collectionUuids?: InputMaybe<Array<Scalars['ID']>>;
  entryUuids?: InputMaybe<Array<Scalars['ID']>>;
  objectUuids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryGetDataObjectsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetDataPageArgs = {
  uuid: Scalars['ID'];
};


export type QueryGetFetchArgs = {
  command: Scalars['String'];
  destination?: InputMaybe<FetchDestination>;
  token: Scalars['String'];
};


export type QueryGetMockDataArgs = {
  entryUuid: Scalars['String'];
};


export type QueryGetPlaidAccessTokenArgs = {
  institutionId: Scalars['String'];
  publicToken: Scalars['String'];
};


export type QueryGetPlaidAccountsArgs = {
  accessToken: Scalars['String'];
};


export type QueryGetPlaidHoldingsArgs = {
  accessToken: Scalars['String'];
};


export type QueryGetPlaidInvestmentTransactionsArgs = {
  accessToken: Scalars['String'];
  accounts?: InputMaybe<Array<Scalars['String']>>;
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetPlaidReauthArgs = {
  accessToken: Scalars['String'];
  institutionId: Scalars['String'];
};


export type QueryGetPlaidTransactionsArgs = {
  accessToken: Scalars['String'];
  accounts?: InputMaybe<Array<Scalars['String']>>;
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetRefreshedFilesArgs = {
  uuids: Array<Scalars['ID']>;
};


export type QueryGetStockArgs = {
  ticker: Scalars['String'];
};


export type QueryGetStockDetailsArgs = {
  ticker: Scalars['String'];
};


export type QueryGetStockHistoryArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  frequency?: InputMaybe<HistoryFrequency>;
  includeAfterHours?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['DateTime'];
  ticker: Scalars['String'];
};


export type QueryGetStockSearchArgs = {
  query: Scalars['String'];
};


export type QueryGetStocksArgs = {
  tickers: Array<Scalars['String']>;
};


export type QueryLaunchArgs = {
  id: Scalars['ID'];
};

export type Rocket = {
  __typename?: 'Rocket';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ShadowUserInput = {
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type StockDetails = {
  __typename?: 'StockDetails';
  cusip?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  exchangeCode: Scalars['String'];
  isCrypto?: Maybe<Scalars['Boolean']>;
  isin?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sedol?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  ticker: Scalars['String'];
};

export type StockHistoryPrice = {
  __typename?: 'StockHistoryPrice';
  adjClose: Scalars['Float'];
  adjHigh: Scalars['Float'];
  adjLow: Scalars['Float'];
  adjOpen: Scalars['Float'];
  adjVolume: Scalars['Float'];
  close: Scalars['Float'];
  date: Scalars['DateTime'];
  divCash: Scalars['Float'];
  high: Scalars['Float'];
  low: Scalars['Float'];
  open: Scalars['Float'];
  splitFactor: Scalars['Float'];
  volume: Scalars['Float'];
};

export type StockPrice = {
  __typename?: 'StockPrice';
  high: Scalars['Float'];
  last: Scalars['String'];
  low: Scalars['Float'];
  open: Scalars['Float'];
  prevClose: Scalars['Float'];
  ticker: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type StockResult = {
  __typename?: 'StockResult';
  active?: Maybe<Scalars['Boolean']>;
  assetType?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  clientMessageAdded: ClientMessage;
  messageAdded: Message;
  updateClientList: Array<Client>;
};

export type TripUpdateResponse = {
  __typename?: 'TripUpdateResponse';
  launches?: Maybe<Array<Maybe<Launch>>>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateItemInput = {
  action: ActionType;
  id: Scalars['String'];
  itemType: CollectionType;
  ordinal: Scalars['Int'];
};

export type UpdateItemOrderInput = {
  id: Scalars['String'];
  itemType: CollectionType;
  ordinal: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  accountDetails?: Maybe<AccountDetails>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  uuid: Scalars['ID'];
};

export type UserInput = {
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type DataCollectionFragment = { __typename?: 'DataCollection', root?: { __typename?: 'DataCollectionData', uuid: string, ownerUuid: string, name: string, description?: string | null | undefined, ordinal: number, collectionUuids: Array<string>, objectUuids: Array<string>, entryUuids: Array<string>, dateCreated?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, ordinal: number }> | null | undefined } | null | undefined, collections?: Array<{ __typename?: 'DataCollectionData', uuid: string, ownerUuid: string, name: string, description?: string | null | undefined, ordinal: number, collectionUuids: Array<string>, objectUuids: Array<string>, entryUuids: Array<string>, dateCreated?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, ordinal: number }> | null | undefined }> | null | undefined, objects?: Array<{ __typename?: 'DataObject', uuid: string, ownerUuid: string, name: string, description: string, dateCreated?: any | null | undefined, active?: boolean | null | undefined, hideFields?: Array<string> | null | undefined, entries?: Array<{ __typename?: 'DataObjectEntry', uuid: string, objectUuid: string, ordinal: number, name: string, type: DataEntryType, schema?: any | null | undefined, description?: string | null | undefined, dateCreated?: any | null | undefined, active?: boolean | null | undefined }> | null | undefined }> | null | undefined, entries?: Array<{ __typename?: 'DataEntry', dataUuid: string, objectUuid: string, title: string, description?: string | null | undefined, dateCreated: any, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, hideFields?: Array<string> | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, childUuid?: string | null | undefined, ordinal: number }> | null | undefined, data: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }>, instances: Array<{ __typename?: 'DataEntryInstance', instanceUuid: string, objectUuid?: string | null | undefined, dateCreated?: any | null | undefined, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, instanceData: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }> }> }> | null | undefined };

export type DataCollectionDataFragment = { __typename?: 'DataCollectionData', uuid: string, ownerUuid: string, name: string, description?: string | null | undefined, ordinal: number, collectionUuids: Array<string>, objectUuids: Array<string>, entryUuids: Array<string>, dateCreated?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, ordinal: number }> | null | undefined };

export type DataEntryFragment = { __typename?: 'DataEntry', dataUuid: string, objectUuid: string, title: string, description?: string | null | undefined, dateCreated: any, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, hideFields?: Array<string> | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, childUuid?: string | null | undefined, ordinal: number }> | null | undefined, data: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }>, instances: Array<{ __typename?: 'DataEntryInstance', instanceUuid: string, objectUuid?: string | null | undefined, dateCreated?: any | null | undefined, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, instanceData: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }> }> };

export type DataEntryDataFragment = { __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined };

export type DataEntryInstanceFragment = { __typename?: 'DataEntryInstance', instanceUuid: string, objectUuid?: string | null | undefined, dateCreated?: any | null | undefined, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, instanceData: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }> };

export type DataObjectFragment = { __typename?: 'DataObject', uuid: string, ownerUuid: string, name: string, description: string, dateCreated?: any | null | undefined, active?: boolean | null | undefined, hideFields?: Array<string> | null | undefined, entries?: Array<{ __typename?: 'DataObjectEntry', uuid: string, objectUuid: string, ordinal: number, name: string, type: DataEntryType, schema?: any | null | undefined, description?: string | null | undefined, dateCreated?: any | null | undefined, active?: boolean | null | undefined }> | null | undefined };

export type DataObjectEntryFragment = { __typename?: 'DataObjectEntry', uuid: string, objectUuid: string, ordinal: number, name: string, type: DataEntryType, schema?: any | null | undefined, description?: string | null | undefined, dateCreated?: any | null | undefined, active?: boolean | null | undefined };

export type DataPageFragment = { __typename?: 'DataPage', uuid: string, ownerUuid: string, name: string, description?: string | null | undefined, dateCreated?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, data: Array<{ __typename?: 'DataPageData', uuid: string, type: CollectionType, itemUuid: string }> };

export type DataPageDataFragment = { __typename?: 'DataPageData', uuid: string, type: CollectionType, itemUuid: string };

export type PlaidAccountFragment = { __typename?: 'PlaidAccount', accountId: string, brokerAccountId?: string | null | undefined, lastFour?: string | null | undefined, name?: string | null | undefined, subtype?: string | null | undefined, type?: string | null | undefined, balances: { __typename?: 'PlaidAccountBalance', available?: number | null | undefined, current?: number | null | undefined } };

export type PlaidSecurityFragment = { __typename?: 'PlaidSecurity', closePrice?: number | null | undefined, closePriceDate?: string | null | undefined, cusip?: string | null | undefined, isin?: string | null | undefined, sedol?: string | null | undefined, name?: string | null | undefined, securityId: string, symbol?: string | null | undefined, type?: string | null | undefined };

export type StockPriceFragment = { __typename?: 'StockPrice', ticker: string, timestamp: any, low: number, high: number, prevClose: number, open: number, last: string };

export type StockHistoryPriceFragment = { __typename?: 'StockHistoryPrice', date: any, open: number, close: number, low: number, high: number, volume: number, adjOpen: number, adjClose: number, adjLow: number, adjHigh: number, adjVolume: number, divCash: number, splitFactor: number };

export type StockResultFragment = { __typename?: 'StockResult', name?: string | null | undefined, ticker?: string | null | undefined, assetType?: string | null | undefined, countryCode?: string | null | undefined, active?: boolean | null | undefined };

export type StockDetailsFragment = { __typename?: 'StockDetails', name: string, ticker: string, cusip?: string | null | undefined, isin?: string | null | undefined, sedol?: string | null | undefined, description: string, exchangeCode: string, startDate?: any | null | undefined, endDate?: any | null | undefined, isCrypto?: boolean | null | undefined };

export type FileFragment = { __typename?: 'File', uuid: string, url: string, filename: string, expiration?: any | null | undefined };

export type FriendFragment = { __typename?: 'Friend', status?: FriendStatus | null | undefined, dateCreated?: any | null | undefined, dateConfirmed?: any | null | undefined, user: { __typename?: 'User', uuid: string, firstName: string, lastName: string, emailAddress: string, dateCreated?: any | null | undefined, accountDetails?: { __typename?: 'AccountDetails', features: Array<Features> } | null | undefined } };

export type UserFragment = { __typename?: 'User', uuid: string, firstName: string, lastName: string, emailAddress: string, dateCreated?: any | null | undefined, accountDetails?: { __typename?: 'AccountDetails', features: Array<Features> } | null | undefined };

export type AddDataCollectionMutationVariables = Exact<{
  dataCollection: DataCollectionInput;
}>;


export type AddDataCollectionMutation = { __typename?: 'Mutation', addDataCollection: { __typename?: 'DataCollectionData', uuid: string, ownerUuid: string, name: string, description?: string | null | undefined, ordinal: number, collectionUuids: Array<string>, objectUuids: Array<string>, entryUuids: Array<string>, dateCreated?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, ordinal: number }> | null | undefined } };

export type UpdateDataCollectionMutationVariables = Exact<{
  dataCollection: DataCollectionInput;
}>;


export type UpdateDataCollectionMutation = { __typename?: 'Mutation', updateDataCollection: { __typename?: 'DataCollectionData', uuid: string, ownerUuid: string, name: string, description?: string | null | undefined, ordinal: number, collectionUuids: Array<string>, objectUuids: Array<string>, entryUuids: Array<string>, dateCreated?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, ordinal: number }> | null | undefined } };

export type DeleteDataCollectionMutationVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type DeleteDataCollectionMutation = { __typename?: 'Mutation', deleteDataCollection: { __typename?: 'DataCollectionData', uuid: string, ownerUuid: string, name: string, description?: string | null | undefined, ordinal: number, collectionUuids: Array<string>, objectUuids: Array<string>, entryUuids: Array<string>, dateCreated?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, ordinal: number }> | null | undefined } };

export type AddDataEntryMutationVariables = Exact<{
  dataEntry: DataEntryInput;
}>;


export type AddDataEntryMutation = { __typename?: 'Mutation', addDataEntry: { __typename?: 'DataEntry', dataUuid: string, objectUuid: string, title: string, description?: string | null | undefined, dateCreated: any, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, hideFields?: Array<string> | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, childUuid?: string | null | undefined, ordinal: number }> | null | undefined, data: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }>, instances: Array<{ __typename?: 'DataEntryInstance', instanceUuid: string, objectUuid?: string | null | undefined, dateCreated?: any | null | undefined, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, instanceData: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }> }> } };

export type UpdateDataEntryMutationVariables = Exact<{
  dataEntry: DataEntryInput;
}>;


export type UpdateDataEntryMutation = { __typename?: 'Mutation', updateDataEntry: { __typename?: 'DataEntry', dataUuid: string, objectUuid: string, title: string, description?: string | null | undefined, dateCreated: any, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, hideFields?: Array<string> | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, childUuid?: string | null | undefined, ordinal: number }> | null | undefined, data: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }>, instances: Array<{ __typename?: 'DataEntryInstance', instanceUuid: string, objectUuid?: string | null | undefined, dateCreated?: any | null | undefined, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, instanceData: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }> }> } };

export type DeleteDataEntryMutationVariables = Exact<{
  objectUuid: Scalars['ID'];
  dataUuid: Scalars['ID'];
}>;


export type DeleteDataEntryMutation = { __typename?: 'Mutation', deleteDataEntry: { __typename?: 'DataEntry', dataUuid: string, objectUuid: string, title: string, description?: string | null | undefined, dateCreated: any, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, hideFields?: Array<string> | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, childUuid?: string | null | undefined, ordinal: number }> | null | undefined, data: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }>, instances: Array<{ __typename?: 'DataEntryInstance', instanceUuid: string, objectUuid?: string | null | undefined, dateCreated?: any | null | undefined, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, instanceData: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }> }> } };

export type PostPlaidLinkTokenMutationVariables = Exact<{
  accessToken?: InputMaybe<Scalars['String']>;
}>;


export type PostPlaidLinkTokenMutation = { __typename?: 'Mutation', postPlaidLinkToken: { __typename?: 'PlaidLinkToken', expiration: any, linkToken: string, requestId: string } };

export type UpdatePlaidLinkedInstitutionMutationVariables = Exact<{
  institution: PlaidLinkedInstitutionInput;
}>;


export type UpdatePlaidLinkedInstitutionMutation = { __typename?: 'Mutation', updatePlaidLinkedInstitution: { __typename?: 'PlaidLinkedInstitution', linkedId: string, institutionId: string, institutionName: string, source?: string | null | undefined, accounts: Array<{ __typename?: 'PlaidAccount', accountId: string, brokerAccountId?: string | null | undefined, lastFour?: string | null | undefined, name?: string | null | undefined, subtype?: string | null | undefined, type?: string | null | undefined, balances: { __typename?: 'PlaidAccountBalance', available?: number | null | undefined, current?: number | null | undefined } }> } };

export type RegisterAlphaUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type RegisterAlphaUserMutation = { __typename?: 'Mutation', registerAlphaUser?: { __typename?: 'AlphaUser', email?: string | null | undefined, status?: AlphaUserType | null | undefined } | null | undefined };

export type SubmitFeedbackMutationVariables = Exact<{
  feedback: FeedbackInput;
}>;


export type SubmitFeedbackMutation = { __typename?: 'Mutation', submitFeedback?: boolean | null | undefined };

export type RegisterUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', registerUser?: { __typename?: 'User', uuid: string, firstName: string, lastName: string, emailAddress: string, dateCreated?: any | null | undefined, accountDetails?: { __typename?: 'AccountDetails', features: Array<Features> } | null | undefined } | null | undefined };

export type DeleteFilesMutationVariables = Exact<{
  uuids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteFilesMutation = { __typename?: 'Mutation', deleteFiles: Array<{ __typename?: 'File', uuid: string, url: string, filename: string, expiration?: any | null | undefined }> };

export type GetDataObjectsQueryVariables = Exact<{
  includeInactive: Scalars['Boolean'];
}>;


export type GetDataObjectsQuery = { __typename?: 'Query', getDataObjects: Array<{ __typename?: 'DataObject', uuid: string, ownerUuid: string, name: string, description: string, dateCreated?: any | null | undefined, active?: boolean | null | undefined, hideFields?: Array<string> | null | undefined, entries?: Array<{ __typename?: 'DataObjectEntry', uuid: string, objectUuid: string, ordinal: number, name: string, type: DataEntryType, schema?: any | null | undefined, description?: string | null | undefined, dateCreated?: any | null | undefined, active?: boolean | null | undefined }> | null | undefined }> };

export type GetDataEntriesQueryVariables = Exact<{
  collectionUuids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  objectUuids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  entryUuids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetDataEntriesQuery = { __typename?: 'Query', getDataEntries: Array<{ __typename?: 'DataEntry', dataUuid: string, objectUuid: string, title: string, description?: string | null | undefined, dateCreated: any, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, hideFields?: Array<string> | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, childUuid?: string | null | undefined, ordinal: number }> | null | undefined, data: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }>, instances: Array<{ __typename?: 'DataEntryInstance', instanceUuid: string, objectUuid?: string | null | undefined, dateCreated?: any | null | undefined, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, instanceData: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }> }> }> };

export type GetDataCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDataCollectionsQuery = { __typename?: 'Query', getDataCollections: Array<{ __typename?: 'DataCollectionData', uuid: string, ownerUuid: string, name: string, description?: string | null | undefined, ordinal: number, collectionUuids: Array<string>, objectUuids: Array<string>, entryUuids: Array<string>, dateCreated?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, ordinal: number }> | null | undefined }> };

export type GetDataCollectionsByIdQueryVariables = Exact<{
  uuids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetDataCollectionsByIdQuery = { __typename?: 'Query', getDataCollectionsById: { __typename?: 'DataCollection', root?: { __typename?: 'DataCollectionData', uuid: string, ownerUuid: string, name: string, description?: string | null | undefined, ordinal: number, collectionUuids: Array<string>, objectUuids: Array<string>, entryUuids: Array<string>, dateCreated?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, ordinal: number }> | null | undefined } | null | undefined, collections?: Array<{ __typename?: 'DataCollectionData', uuid: string, ownerUuid: string, name: string, description?: string | null | undefined, ordinal: number, collectionUuids: Array<string>, objectUuids: Array<string>, entryUuids: Array<string>, dateCreated?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, ordinal: number }> | null | undefined }> | null | undefined, objects?: Array<{ __typename?: 'DataObject', uuid: string, ownerUuid: string, name: string, description: string, dateCreated?: any | null | undefined, active?: boolean | null | undefined, hideFields?: Array<string> | null | undefined, entries?: Array<{ __typename?: 'DataObjectEntry', uuid: string, objectUuid: string, ordinal: number, name: string, type: DataEntryType, schema?: any | null | undefined, description?: string | null | undefined, dateCreated?: any | null | undefined, active?: boolean | null | undefined }> | null | undefined }> | null | undefined, entries?: Array<{ __typename?: 'DataEntry', dataUuid: string, objectUuid: string, title: string, description?: string | null | undefined, dateCreated: any, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, hideFields?: Array<string> | null | undefined, parent?: Array<{ __typename?: 'DataParent', type: CollectionType, uuid: string, childUuid?: string | null | undefined, ordinal: number }> | null | undefined, data: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }>, instances: Array<{ __typename?: 'DataEntryInstance', instanceUuid: string, objectUuid?: string | null | undefined, dateCreated?: any | null | undefined, dateDue?: any | null | undefined, dateCompleted?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, instanceData: Array<{ __typename?: 'DataEntryData', entryUuid: string, data?: string | null | undefined, customName?: string | null | undefined }> }> }> | null | undefined } };

export type GetDataPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDataPagesQuery = { __typename?: 'Query', getDataPages: Array<{ __typename?: 'DataPage', uuid: string, ownerUuid: string, name: string, description?: string | null | undefined, dateCreated?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, data: Array<{ __typename?: 'DataPageData', uuid: string, type: CollectionType, itemUuid: string }> }> };

export type GetDataPageQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetDataPageQuery = { __typename?: 'Query', getDataPage: { __typename?: 'DataPage', uuid: string, ownerUuid: string, name: string, description?: string | null | undefined, dateCreated?: any | null | undefined, active?: boolean | null | undefined, dateRemoved?: any | null | undefined, data: Array<{ __typename?: 'DataPageData', uuid: string, type: CollectionType, itemUuid: string }> } };

export type GetPlaidLinkedInstitutionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlaidLinkedInstitutionsQuery = { __typename?: 'Query', getPlaidLinkedInstitutions: Array<{ __typename?: 'PlaidLinkedInstitution', linkedId: string, institutionId: string, institutionName: string, source?: string | null | undefined, accounts: Array<{ __typename?: 'PlaidAccount', accountId: string, brokerAccountId?: string | null | undefined, lastFour?: string | null | undefined, name?: string | null | undefined, subtype?: string | null | undefined, type?: string | null | undefined, balances: { __typename?: 'PlaidAccountBalance', available?: number | null | undefined, current?: number | null | undefined } }> }> };

export type GetPlaidAccessTokenQueryVariables = Exact<{
  institutionId: Scalars['String'];
  publicToken: Scalars['String'];
}>;


export type GetPlaidAccessTokenQuery = { __typename?: 'Query', getPlaidAccessToken: { __typename?: 'PlaidLinkedInstitution', linkedId: string, institutionId: string, institutionName: string, source?: string | null | undefined, accounts: Array<{ __typename?: 'PlaidAccount', accountId: string, brokerAccountId?: string | null | undefined, lastFour?: string | null | undefined, name?: string | null | undefined, subtype?: string | null | undefined, type?: string | null | undefined, balances: { __typename?: 'PlaidAccountBalance', available?: number | null | undefined, current?: number | null | undefined } }> } };

export type GetPlaidAccountsQueryVariables = Exact<{
  accessToken: Scalars['String'];
}>;


export type GetPlaidAccountsQuery = { __typename?: 'Query', getPlaidAccounts: Array<{ __typename?: 'PlaidAccount', accountId: string, brokerAccountId?: string | null | undefined, lastFour?: string | null | undefined, name?: string | null | undefined, subtype?: string | null | undefined, type?: string | null | undefined, balances: { __typename?: 'PlaidAccountBalance', available?: number | null | undefined, current?: number | null | undefined } }> };

export type GetPlaidInvestmentTransactionsQueryVariables = Exact<{
  accessToken: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  accounts?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetPlaidInvestmentTransactionsQuery = { __typename?: 'Query', getPlaidInvestmentTransactions: { __typename?: 'PlaidInvestment', accounts: Array<{ __typename?: 'PlaidAccount', accountId: string, brokerAccountId?: string | null | undefined, lastFour?: string | null | undefined, name?: string | null | undefined, subtype?: string | null | undefined, type?: string | null | undefined, balances: { __typename?: 'PlaidAccountBalance', available?: number | null | undefined, current?: number | null | undefined } }>, securities: Array<{ __typename?: 'PlaidSecurity', closePrice?: number | null | undefined, closePriceDate?: string | null | undefined, cusip?: string | null | undefined, isin?: string | null | undefined, sedol?: string | null | undefined, name?: string | null | undefined, securityId: string, symbol?: string | null | undefined, type?: string | null | undefined }>, transactions: Array<{ __typename?: 'PlaidInvestmentTransaction', accountId: string, amount?: number | null | undefined, date?: string | null | undefined, fees?: number | null | undefined, name?: string | null | undefined, price?: number | null | undefined, quantity?: number | null | undefined, transactionId: string, securityId?: string | null | undefined, subtype?: string | null | undefined, type?: string | null | undefined }> } };

export type GetPlaidTransactionsQueryVariables = Exact<{
  accessToken: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  accounts?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetPlaidTransactionsQuery = { __typename?: 'Query', getPlaidTransactions: { __typename?: 'PlaidTransactions', value: string, accounts: Array<{ __typename?: 'PlaidAccount', accountId: string, brokerAccountId?: string | null | undefined, lastFour?: string | null | undefined, name?: string | null | undefined, subtype?: string | null | undefined, type?: string | null | undefined, balances: { __typename?: 'PlaidAccountBalance', available?: number | null | undefined, current?: number | null | undefined } }>, transactions: Array<{ __typename?: 'PlaidTransaction', accountId: string, amount?: number | null | undefined, category: Array<string>, categoryId?: string | null | undefined, date?: string | null | undefined, merchantName?: string | null | undefined, name?: string | null | undefined, pending?: boolean | null | undefined, transactionId: string, transactionType?: string | null | undefined }> } };

export type GetPlaidHoldingsQueryVariables = Exact<{
  accessToken: Scalars['String'];
}>;


export type GetPlaidHoldingsQuery = { __typename?: 'Query', getPlaidHoldings: { __typename?: 'PlaidHoldings', accounts: Array<{ __typename?: 'PlaidAccount', accountId: string, brokerAccountId?: string | null | undefined, lastFour?: string | null | undefined, name?: string | null | undefined, subtype?: string | null | undefined, type?: string | null | undefined, balances: { __typename?: 'PlaidAccountBalance', available?: number | null | undefined, current?: number | null | undefined } }>, securities: Array<{ __typename?: 'PlaidSecurity', closePrice?: number | null | undefined, closePriceDate?: string | null | undefined, cusip?: string | null | undefined, isin?: string | null | undefined, sedol?: string | null | undefined, name?: string | null | undefined, securityId: string, symbol?: string | null | undefined, type?: string | null | undefined }>, holdings: Array<{ __typename?: 'PlaidHolding', accountId?: string | null | undefined, costBasis?: number | null | undefined, price?: number | null | undefined, priceDate?: string | null | undefined, value?: number | null | undefined, quantity?: number | null | undefined, securityId?: string | null | undefined }> } };

export type GetCoinbaseDataQueryVariables = Exact<{
  dataType: Scalars['String'];
  account?: InputMaybe<Scalars['String']>;
}>;


export type GetCoinbaseDataQuery = { __typename?: 'Query', getCoinbaseData: string };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'User', uuid: string, firstName: string, lastName: string, emailAddress: string, dateCreated?: any | null | undefined, accountDetails?: { __typename?: 'AccountDetails', features: Array<Features> } | null | undefined } };

export type PingQueryVariables = Exact<{ [key: string]: never; }>;


export type PingQuery = { __typename?: 'Query', ping: string };

export type GetStockQueryVariables = Exact<{
  ticker: Scalars['String'];
}>;


export type GetStockQuery = { __typename?: 'Query', getStock: { __typename?: 'StockPrice', ticker: string, timestamp: any, low: number, high: number, prevClose: number, open: number, last: string } };

export type GetStockHistoryQueryVariables = Exact<{
  ticker: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  includeAfterHours?: InputMaybe<Scalars['Boolean']>;
  frequency?: InputMaybe<HistoryFrequency>;
}>;


export type GetStockHistoryQuery = { __typename?: 'Query', getStockHistory: Array<{ __typename?: 'StockHistoryPrice', date: any, open: number, close: number, low: number, high: number, volume: number, adjOpen: number, adjClose: number, adjLow: number, adjHigh: number, adjVolume: number, divCash: number, splitFactor: number }> };

export type GetStocksQueryVariables = Exact<{
  tickers: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetStocksQuery = { __typename?: 'Query', getStocks: Array<{ __typename?: 'StockPrice', ticker: string, timestamp: any, low: number, high: number, prevClose: number, open: number, last: string }> };

export type GetStockSearchQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type GetStockSearchQuery = { __typename?: 'Query', getStockSearch: Array<{ __typename?: 'StockResult', name?: string | null | undefined, ticker?: string | null | undefined, assetType?: string | null | undefined, countryCode?: string | null | undefined, active?: boolean | null | undefined }> };

export type GetStockDetailsQueryVariables = Exact<{
  ticker: Scalars['String'];
}>;


export type GetStockDetailsQuery = { __typename?: 'Query', getStockDetails: { __typename?: 'StockDetails', name: string, ticker: string, cusip?: string | null | undefined, isin?: string | null | undefined, sedol?: string | null | undefined, description: string, exchangeCode: string, startDate?: any | null | undefined, endDate?: any | null | undefined, isCrypto?: boolean | null | undefined } };

export type GetFetchQueryVariables = Exact<{
  command: Scalars['String'];
  token: Scalars['String'];
  destination?: InputMaybe<FetchDestination>;
}>;


export type GetFetchQuery = { __typename?: 'Query', getFetch: string };

export type GetFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilesQuery = { __typename?: 'Query', getFiles: Array<{ __typename?: 'File', uuid: string, url: string, filename: string, expiration?: any | null | undefined }> };

export type GetRefreshedFilesQueryVariables = Exact<{
  uuids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetRefreshedFilesQuery = { __typename?: 'Query', getRefreshedFiles: Array<{ __typename?: 'File', uuid: string, url: string, filename: string, expiration?: any | null | undefined }> };

export type GetFriendsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFriendsQuery = { __typename?: 'Query', getFriends: Array<{ __typename?: 'Friend', status?: FriendStatus | null | undefined, dateCreated?: any | null | undefined, dateConfirmed?: any | null | undefined, user: { __typename?: 'User', uuid: string, firstName: string, lastName: string, emailAddress: string, dateCreated?: any | null | undefined, accountDetails?: { __typename?: 'AccountDetails', features: Array<Features> } | null | undefined } }> };

export const DataCollectionDataFragmentDoc = gql`
    fragment DataCollectionData on DataCollectionData {
  uuid
  parent {
    type
    uuid
    ordinal
  }
  ownerUuid
  name
  description
  ordinal
  collectionUuids
  objectUuids
  entryUuids
  dateCreated
  active
  dateRemoved
}
    `;
export const DataObjectEntryFragmentDoc = gql`
    fragment DataObjectEntry on DataObjectEntry {
  uuid
  objectUuid
  ordinal
  name
  type
  schema
  description
  dateCreated
  active
}
    `;
export const DataObjectFragmentDoc = gql`
    fragment DataObject on DataObject {
  uuid
  ownerUuid
  name
  description
  entries {
    ...DataObjectEntry
  }
  dateCreated
  active
  hideFields
}
    ${DataObjectEntryFragmentDoc}`;
export const DataEntryDataFragmentDoc = gql`
    fragment DataEntryData on DataEntryData {
  entryUuid
  data
  customName
}
    `;
export const DataEntryInstanceFragmentDoc = gql`
    fragment DataEntryInstance on DataEntryInstance {
  instanceUuid
  objectUuid
  instanceData {
    ...DataEntryData
  }
  dateCreated
  dateDue
  dateCompleted
  active
  dateRemoved
}
    ${DataEntryDataFragmentDoc}`;
export const DataEntryFragmentDoc = gql`
    fragment DataEntry on DataEntry {
  dataUuid
  objectUuid
  title
  description
  parent {
    type
    uuid
    childUuid
    ordinal
  }
  data {
    ...DataEntryData
  }
  instances {
    ...DataEntryInstance
  }
  dateCreated
  dateDue
  dateCompleted
  active
  dateRemoved
  hideFields
}
    ${DataEntryDataFragmentDoc}
${DataEntryInstanceFragmentDoc}`;
export const DataCollectionFragmentDoc = gql`
    fragment DataCollection on DataCollection {
  root {
    ...DataCollectionData
  }
  collections {
    ...DataCollectionData
  }
  objects {
    ...DataObject
  }
  entries {
    ...DataEntry
  }
}
    ${DataCollectionDataFragmentDoc}
${DataObjectFragmentDoc}
${DataEntryFragmentDoc}`;
export const DataPageDataFragmentDoc = gql`
    fragment DataPageData on DataPageData {
  uuid
  type
  itemUuid
}
    `;
export const DataPageFragmentDoc = gql`
    fragment DataPage on DataPage {
  uuid
  data {
    ...DataPageData
  }
  ownerUuid
  name
  description
  dateCreated
  active
  dateRemoved
}
    ${DataPageDataFragmentDoc}`;
export const PlaidAccountFragmentDoc = gql`
    fragment PlaidAccount on PlaidAccount {
  accountId
  brokerAccountId
  balances {
    available
    current
  }
  lastFour
  name
  subtype
  type
}
    `;
export const PlaidSecurityFragmentDoc = gql`
    fragment PlaidSecurity on PlaidSecurity {
  closePrice
  closePriceDate
  cusip
  isin
  sedol
  name
  securityId
  symbol
  type
}
    `;
export const StockPriceFragmentDoc = gql`
    fragment StockPrice on StockPrice {
  ticker
  timestamp
  low
  high
  prevClose
  open
  last
}
    `;
export const StockHistoryPriceFragmentDoc = gql`
    fragment StockHistoryPrice on StockHistoryPrice {
  date
  open
  close
  low
  high
  volume
  adjOpen
  adjClose
  adjLow
  adjHigh
  adjVolume
  divCash
  splitFactor
}
    `;
export const StockResultFragmentDoc = gql`
    fragment StockResult on StockResult {
  name
  ticker
  assetType
  countryCode
  active
}
    `;
export const StockDetailsFragmentDoc = gql`
    fragment StockDetails on StockDetails {
  name
  ticker
  cusip
  isin
  sedol
  description
  exchangeCode
  startDate
  endDate
  isCrypto
}
    `;
export const FileFragmentDoc = gql`
    fragment File on File {
  uuid
  url
  filename
  expiration
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  uuid
  firstName
  lastName
  emailAddress
  dateCreated
  accountDetails {
    features
  }
}
    `;
export const FriendFragmentDoc = gql`
    fragment Friend on Friend {
  user {
    ...User
  }
  status
  dateCreated
  dateConfirmed
}
    ${UserFragmentDoc}`;
export const AddDataCollectionDocument = gql`
    mutation AddDataCollection($dataCollection: DataCollectionInput!) {
  addDataCollection(dataCollection: $dataCollection) {
    ...DataCollectionData
  }
}
    ${DataCollectionDataFragmentDoc}`;
export type AddDataCollectionMutationFn = Apollo.MutationFunction<AddDataCollectionMutation, AddDataCollectionMutationVariables>;

/**
 * __useAddDataCollectionMutation__
 *
 * To run a mutation, you first call `useAddDataCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDataCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDataCollectionMutation, { data, loading, error }] = useAddDataCollectionMutation({
 *   variables: {
 *      dataCollection: // value for 'dataCollection'
 *   },
 * });
 */
export function useAddDataCollectionMutation(baseOptions?: Apollo.MutationHookOptions<AddDataCollectionMutation, AddDataCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDataCollectionMutation, AddDataCollectionMutationVariables>(AddDataCollectionDocument, options);
      }
export type AddDataCollectionMutationHookResult = ReturnType<typeof useAddDataCollectionMutation>;
export type AddDataCollectionMutationResult = Apollo.MutationResult<AddDataCollectionMutation>;
export type AddDataCollectionMutationOptions = Apollo.BaseMutationOptions<AddDataCollectionMutation, AddDataCollectionMutationVariables>;
export const UpdateDataCollectionDocument = gql`
    mutation UpdateDataCollection($dataCollection: DataCollectionInput!) {
  updateDataCollection(dataCollection: $dataCollection) {
    ...DataCollectionData
  }
}
    ${DataCollectionDataFragmentDoc}`;
export type UpdateDataCollectionMutationFn = Apollo.MutationFunction<UpdateDataCollectionMutation, UpdateDataCollectionMutationVariables>;

/**
 * __useUpdateDataCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateDataCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataCollectionMutation, { data, loading, error }] = useUpdateDataCollectionMutation({
 *   variables: {
 *      dataCollection: // value for 'dataCollection'
 *   },
 * });
 */
export function useUpdateDataCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDataCollectionMutation, UpdateDataCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDataCollectionMutation, UpdateDataCollectionMutationVariables>(UpdateDataCollectionDocument, options);
      }
export type UpdateDataCollectionMutationHookResult = ReturnType<typeof useUpdateDataCollectionMutation>;
export type UpdateDataCollectionMutationResult = Apollo.MutationResult<UpdateDataCollectionMutation>;
export type UpdateDataCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateDataCollectionMutation, UpdateDataCollectionMutationVariables>;
export const DeleteDataCollectionDocument = gql`
    mutation DeleteDataCollection($uuid: ID!) {
  deleteDataCollection(collectionUuid: $uuid) {
    ...DataCollectionData
  }
}
    ${DataCollectionDataFragmentDoc}`;
export type DeleteDataCollectionMutationFn = Apollo.MutationFunction<DeleteDataCollectionMutation, DeleteDataCollectionMutationVariables>;

/**
 * __useDeleteDataCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteDataCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataCollectionMutation, { data, loading, error }] = useDeleteDataCollectionMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteDataCollectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDataCollectionMutation, DeleteDataCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDataCollectionMutation, DeleteDataCollectionMutationVariables>(DeleteDataCollectionDocument, options);
      }
export type DeleteDataCollectionMutationHookResult = ReturnType<typeof useDeleteDataCollectionMutation>;
export type DeleteDataCollectionMutationResult = Apollo.MutationResult<DeleteDataCollectionMutation>;
export type DeleteDataCollectionMutationOptions = Apollo.BaseMutationOptions<DeleteDataCollectionMutation, DeleteDataCollectionMutationVariables>;
export const AddDataEntryDocument = gql`
    mutation AddDataEntry($dataEntry: DataEntryInput!) {
  addDataEntry(dataEntry: $dataEntry) {
    ...DataEntry
  }
}
    ${DataEntryFragmentDoc}`;
export type AddDataEntryMutationFn = Apollo.MutationFunction<AddDataEntryMutation, AddDataEntryMutationVariables>;

/**
 * __useAddDataEntryMutation__
 *
 * To run a mutation, you first call `useAddDataEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDataEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDataEntryMutation, { data, loading, error }] = useAddDataEntryMutation({
 *   variables: {
 *      dataEntry: // value for 'dataEntry'
 *   },
 * });
 */
export function useAddDataEntryMutation(baseOptions?: Apollo.MutationHookOptions<AddDataEntryMutation, AddDataEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDataEntryMutation, AddDataEntryMutationVariables>(AddDataEntryDocument, options);
      }
export type AddDataEntryMutationHookResult = ReturnType<typeof useAddDataEntryMutation>;
export type AddDataEntryMutationResult = Apollo.MutationResult<AddDataEntryMutation>;
export type AddDataEntryMutationOptions = Apollo.BaseMutationOptions<AddDataEntryMutation, AddDataEntryMutationVariables>;
export const UpdateDataEntryDocument = gql`
    mutation UpdateDataEntry($dataEntry: DataEntryInput!) {
  updateDataEntry(dataEntry: $dataEntry) {
    ...DataEntry
  }
}
    ${DataEntryFragmentDoc}`;
export type UpdateDataEntryMutationFn = Apollo.MutationFunction<UpdateDataEntryMutation, UpdateDataEntryMutationVariables>;

/**
 * __useUpdateDataEntryMutation__
 *
 * To run a mutation, you first call `useUpdateDataEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataEntryMutation, { data, loading, error }] = useUpdateDataEntryMutation({
 *   variables: {
 *      dataEntry: // value for 'dataEntry'
 *   },
 * });
 */
export function useUpdateDataEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDataEntryMutation, UpdateDataEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDataEntryMutation, UpdateDataEntryMutationVariables>(UpdateDataEntryDocument, options);
      }
export type UpdateDataEntryMutationHookResult = ReturnType<typeof useUpdateDataEntryMutation>;
export type UpdateDataEntryMutationResult = Apollo.MutationResult<UpdateDataEntryMutation>;
export type UpdateDataEntryMutationOptions = Apollo.BaseMutationOptions<UpdateDataEntryMutation, UpdateDataEntryMutationVariables>;
export const DeleteDataEntryDocument = gql`
    mutation DeleteDataEntry($objectUuid: ID!, $dataUuid: ID!) {
  deleteDataEntry(objectUuid: $objectUuid, dataUuid: $dataUuid) {
    ...DataEntry
  }
}
    ${DataEntryFragmentDoc}`;
export type DeleteDataEntryMutationFn = Apollo.MutationFunction<DeleteDataEntryMutation, DeleteDataEntryMutationVariables>;

/**
 * __useDeleteDataEntryMutation__
 *
 * To run a mutation, you first call `useDeleteDataEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataEntryMutation, { data, loading, error }] = useDeleteDataEntryMutation({
 *   variables: {
 *      objectUuid: // value for 'objectUuid'
 *      dataUuid: // value for 'dataUuid'
 *   },
 * });
 */
export function useDeleteDataEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDataEntryMutation, DeleteDataEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDataEntryMutation, DeleteDataEntryMutationVariables>(DeleteDataEntryDocument, options);
      }
export type DeleteDataEntryMutationHookResult = ReturnType<typeof useDeleteDataEntryMutation>;
export type DeleteDataEntryMutationResult = Apollo.MutationResult<DeleteDataEntryMutation>;
export type DeleteDataEntryMutationOptions = Apollo.BaseMutationOptions<DeleteDataEntryMutation, DeleteDataEntryMutationVariables>;
export const PostPlaidLinkTokenDocument = gql`
    mutation PostPlaidLinkToken($accessToken: String) {
  postPlaidLinkToken(accessToken: $accessToken) {
    expiration
    linkToken
    requestId
  }
}
    `;
export type PostPlaidLinkTokenMutationFn = Apollo.MutationFunction<PostPlaidLinkTokenMutation, PostPlaidLinkTokenMutationVariables>;

/**
 * __usePostPlaidLinkTokenMutation__
 *
 * To run a mutation, you first call `usePostPlaidLinkTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostPlaidLinkTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postPlaidLinkTokenMutation, { data, loading, error }] = usePostPlaidLinkTokenMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function usePostPlaidLinkTokenMutation(baseOptions?: Apollo.MutationHookOptions<PostPlaidLinkTokenMutation, PostPlaidLinkTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostPlaidLinkTokenMutation, PostPlaidLinkTokenMutationVariables>(PostPlaidLinkTokenDocument, options);
      }
export type PostPlaidLinkTokenMutationHookResult = ReturnType<typeof usePostPlaidLinkTokenMutation>;
export type PostPlaidLinkTokenMutationResult = Apollo.MutationResult<PostPlaidLinkTokenMutation>;
export type PostPlaidLinkTokenMutationOptions = Apollo.BaseMutationOptions<PostPlaidLinkTokenMutation, PostPlaidLinkTokenMutationVariables>;
export const UpdatePlaidLinkedInstitutionDocument = gql`
    mutation UpdatePlaidLinkedInstitution($institution: PlaidLinkedInstitutionInput!) {
  updatePlaidLinkedInstitution(institution: $institution) {
    linkedId
    institutionId
    institutionName
    accounts {
      ...PlaidAccount
    }
    source
  }
}
    ${PlaidAccountFragmentDoc}`;
export type UpdatePlaidLinkedInstitutionMutationFn = Apollo.MutationFunction<UpdatePlaidLinkedInstitutionMutation, UpdatePlaidLinkedInstitutionMutationVariables>;

/**
 * __useUpdatePlaidLinkedInstitutionMutation__
 *
 * To run a mutation, you first call `useUpdatePlaidLinkedInstitutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaidLinkedInstitutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaidLinkedInstitutionMutation, { data, loading, error }] = useUpdatePlaidLinkedInstitutionMutation({
 *   variables: {
 *      institution: // value for 'institution'
 *   },
 * });
 */
export function useUpdatePlaidLinkedInstitutionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaidLinkedInstitutionMutation, UpdatePlaidLinkedInstitutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaidLinkedInstitutionMutation, UpdatePlaidLinkedInstitutionMutationVariables>(UpdatePlaidLinkedInstitutionDocument, options);
      }
export type UpdatePlaidLinkedInstitutionMutationHookResult = ReturnType<typeof useUpdatePlaidLinkedInstitutionMutation>;
export type UpdatePlaidLinkedInstitutionMutationResult = Apollo.MutationResult<UpdatePlaidLinkedInstitutionMutation>;
export type UpdatePlaidLinkedInstitutionMutationOptions = Apollo.BaseMutationOptions<UpdatePlaidLinkedInstitutionMutation, UpdatePlaidLinkedInstitutionMutationVariables>;
export const RegisterAlphaUserDocument = gql`
    mutation RegisterAlphaUser($user: UserInput!) {
  registerAlphaUser(user: $user) {
    email
    status
  }
}
    `;
export type RegisterAlphaUserMutationFn = Apollo.MutationFunction<RegisterAlphaUserMutation, RegisterAlphaUserMutationVariables>;

/**
 * __useRegisterAlphaUserMutation__
 *
 * To run a mutation, you first call `useRegisterAlphaUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAlphaUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAlphaUserMutation, { data, loading, error }] = useRegisterAlphaUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useRegisterAlphaUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterAlphaUserMutation, RegisterAlphaUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterAlphaUserMutation, RegisterAlphaUserMutationVariables>(RegisterAlphaUserDocument, options);
      }
export type RegisterAlphaUserMutationHookResult = ReturnType<typeof useRegisterAlphaUserMutation>;
export type RegisterAlphaUserMutationResult = Apollo.MutationResult<RegisterAlphaUserMutation>;
export type RegisterAlphaUserMutationOptions = Apollo.BaseMutationOptions<RegisterAlphaUserMutation, RegisterAlphaUserMutationVariables>;
export const SubmitFeedbackDocument = gql`
    mutation SubmitFeedback($feedback: FeedbackInput!) {
  submitFeedback(feedback: $feedback)
}
    `;
export type SubmitFeedbackMutationFn = Apollo.MutationFunction<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>;

/**
 * __useSubmitFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFeedbackMutation, { data, loading, error }] = useSubmitFeedbackMutation({
 *   variables: {
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useSubmitFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>(SubmitFeedbackDocument, options);
      }
export type SubmitFeedbackMutationHookResult = ReturnType<typeof useSubmitFeedbackMutation>;
export type SubmitFeedbackMutationResult = Apollo.MutationResult<SubmitFeedbackMutation>;
export type SubmitFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>;
export const RegisterUserDocument = gql`
    mutation RegisterUser($user: UserInput!) {
  registerUser(user: $user) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const DeleteFilesDocument = gql`
    mutation DeleteFiles($uuids: [ID!]!) {
  deleteFiles(uuids: $uuids) {
    ...File
  }
}
    ${FileFragmentDoc}`;
export type DeleteFilesMutationFn = Apollo.MutationFunction<DeleteFilesMutation, DeleteFilesMutationVariables>;

/**
 * __useDeleteFilesMutation__
 *
 * To run a mutation, you first call `useDeleteFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilesMutation, { data, loading, error }] = useDeleteFilesMutation({
 *   variables: {
 *      uuids: // value for 'uuids'
 *   },
 * });
 */
export function useDeleteFilesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFilesMutation, DeleteFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFilesMutation, DeleteFilesMutationVariables>(DeleteFilesDocument, options);
      }
export type DeleteFilesMutationHookResult = ReturnType<typeof useDeleteFilesMutation>;
export type DeleteFilesMutationResult = Apollo.MutationResult<DeleteFilesMutation>;
export type DeleteFilesMutationOptions = Apollo.BaseMutationOptions<DeleteFilesMutation, DeleteFilesMutationVariables>;
export const GetDataObjectsDocument = gql`
    query GetDataObjects($includeInactive: Boolean!) {
  getDataObjects(includeInactive: $includeInactive) {
    ...DataObject
  }
}
    ${DataObjectFragmentDoc}`;

/**
 * __useGetDataObjectsQuery__
 *
 * To run a query within a React component, call `useGetDataObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataObjectsQuery({
 *   variables: {
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetDataObjectsQuery(baseOptions: Apollo.QueryHookOptions<GetDataObjectsQuery, GetDataObjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataObjectsQuery, GetDataObjectsQueryVariables>(GetDataObjectsDocument, options);
      }
export function useGetDataObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataObjectsQuery, GetDataObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataObjectsQuery, GetDataObjectsQueryVariables>(GetDataObjectsDocument, options);
        }
export type GetDataObjectsQueryHookResult = ReturnType<typeof useGetDataObjectsQuery>;
export type GetDataObjectsLazyQueryHookResult = ReturnType<typeof useGetDataObjectsLazyQuery>;
export type GetDataObjectsQueryResult = Apollo.QueryResult<GetDataObjectsQuery, GetDataObjectsQueryVariables>;
export const GetDataEntriesDocument = gql`
    query GetDataEntries($collectionUuids: [ID!], $objectUuids: [ID!], $entryUuids: [ID!]) {
  getDataEntries(
    collectionUuids: $collectionUuids
    objectUuids: $objectUuids
    entryUuids: $entryUuids
  ) {
    ...DataEntry
  }
}
    ${DataEntryFragmentDoc}`;

/**
 * __useGetDataEntriesQuery__
 *
 * To run a query within a React component, call `useGetDataEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataEntriesQuery({
 *   variables: {
 *      collectionUuids: // value for 'collectionUuids'
 *      objectUuids: // value for 'objectUuids'
 *      entryUuids: // value for 'entryUuids'
 *   },
 * });
 */
export function useGetDataEntriesQuery(baseOptions?: Apollo.QueryHookOptions<GetDataEntriesQuery, GetDataEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataEntriesQuery, GetDataEntriesQueryVariables>(GetDataEntriesDocument, options);
      }
export function useGetDataEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataEntriesQuery, GetDataEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataEntriesQuery, GetDataEntriesQueryVariables>(GetDataEntriesDocument, options);
        }
export type GetDataEntriesQueryHookResult = ReturnType<typeof useGetDataEntriesQuery>;
export type GetDataEntriesLazyQueryHookResult = ReturnType<typeof useGetDataEntriesLazyQuery>;
export type GetDataEntriesQueryResult = Apollo.QueryResult<GetDataEntriesQuery, GetDataEntriesQueryVariables>;
export const GetDataCollectionsDocument = gql`
    query GetDataCollections {
  getDataCollections {
    ...DataCollectionData
  }
}
    ${DataCollectionDataFragmentDoc}`;

/**
 * __useGetDataCollectionsQuery__
 *
 * To run a query within a React component, call `useGetDataCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDataCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDataCollectionsQuery, GetDataCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataCollectionsQuery, GetDataCollectionsQueryVariables>(GetDataCollectionsDocument, options);
      }
export function useGetDataCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataCollectionsQuery, GetDataCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataCollectionsQuery, GetDataCollectionsQueryVariables>(GetDataCollectionsDocument, options);
        }
export type GetDataCollectionsQueryHookResult = ReturnType<typeof useGetDataCollectionsQuery>;
export type GetDataCollectionsLazyQueryHookResult = ReturnType<typeof useGetDataCollectionsLazyQuery>;
export type GetDataCollectionsQueryResult = Apollo.QueryResult<GetDataCollectionsQuery, GetDataCollectionsQueryVariables>;
export const GetDataCollectionsByIdDocument = gql`
    query GetDataCollectionsById($uuids: [ID!]!) {
  getDataCollectionsById(uuids: $uuids) {
    ...DataCollection
  }
}
    ${DataCollectionFragmentDoc}`;

/**
 * __useGetDataCollectionsByIdQuery__
 *
 * To run a query within a React component, call `useGetDataCollectionsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataCollectionsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataCollectionsByIdQuery({
 *   variables: {
 *      uuids: // value for 'uuids'
 *   },
 * });
 */
export function useGetDataCollectionsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDataCollectionsByIdQuery, GetDataCollectionsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataCollectionsByIdQuery, GetDataCollectionsByIdQueryVariables>(GetDataCollectionsByIdDocument, options);
      }
export function useGetDataCollectionsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataCollectionsByIdQuery, GetDataCollectionsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataCollectionsByIdQuery, GetDataCollectionsByIdQueryVariables>(GetDataCollectionsByIdDocument, options);
        }
export type GetDataCollectionsByIdQueryHookResult = ReturnType<typeof useGetDataCollectionsByIdQuery>;
export type GetDataCollectionsByIdLazyQueryHookResult = ReturnType<typeof useGetDataCollectionsByIdLazyQuery>;
export type GetDataCollectionsByIdQueryResult = Apollo.QueryResult<GetDataCollectionsByIdQuery, GetDataCollectionsByIdQueryVariables>;
export const GetDataPagesDocument = gql`
    query GetDataPages {
  getDataPages {
    ...DataPage
  }
}
    ${DataPageFragmentDoc}`;

/**
 * __useGetDataPagesQuery__
 *
 * To run a query within a React component, call `useGetDataPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataPagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDataPagesQuery(baseOptions?: Apollo.QueryHookOptions<GetDataPagesQuery, GetDataPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataPagesQuery, GetDataPagesQueryVariables>(GetDataPagesDocument, options);
      }
export function useGetDataPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataPagesQuery, GetDataPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataPagesQuery, GetDataPagesQueryVariables>(GetDataPagesDocument, options);
        }
export type GetDataPagesQueryHookResult = ReturnType<typeof useGetDataPagesQuery>;
export type GetDataPagesLazyQueryHookResult = ReturnType<typeof useGetDataPagesLazyQuery>;
export type GetDataPagesQueryResult = Apollo.QueryResult<GetDataPagesQuery, GetDataPagesQueryVariables>;
export const GetDataPageDocument = gql`
    query GetDataPage($uuid: ID!) {
  getDataPage(uuid: $uuid) {
    ...DataPage
  }
}
    ${DataPageFragmentDoc}`;

/**
 * __useGetDataPageQuery__
 *
 * To run a query within a React component, call `useGetDataPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataPageQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetDataPageQuery(baseOptions: Apollo.QueryHookOptions<GetDataPageQuery, GetDataPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataPageQuery, GetDataPageQueryVariables>(GetDataPageDocument, options);
      }
export function useGetDataPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataPageQuery, GetDataPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataPageQuery, GetDataPageQueryVariables>(GetDataPageDocument, options);
        }
export type GetDataPageQueryHookResult = ReturnType<typeof useGetDataPageQuery>;
export type GetDataPageLazyQueryHookResult = ReturnType<typeof useGetDataPageLazyQuery>;
export type GetDataPageQueryResult = Apollo.QueryResult<GetDataPageQuery, GetDataPageQueryVariables>;
export const GetPlaidLinkedInstitutionsDocument = gql`
    query GetPlaidLinkedInstitutions {
  getPlaidLinkedInstitutions {
    linkedId
    institutionId
    institutionName
    accounts {
      ...PlaidAccount
    }
    source
  }
}
    ${PlaidAccountFragmentDoc}`;

/**
 * __useGetPlaidLinkedInstitutionsQuery__
 *
 * To run a query within a React component, call `useGetPlaidLinkedInstitutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaidLinkedInstitutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaidLinkedInstitutionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlaidLinkedInstitutionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPlaidLinkedInstitutionsQuery, GetPlaidLinkedInstitutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaidLinkedInstitutionsQuery, GetPlaidLinkedInstitutionsQueryVariables>(GetPlaidLinkedInstitutionsDocument, options);
      }
export function useGetPlaidLinkedInstitutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaidLinkedInstitutionsQuery, GetPlaidLinkedInstitutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaidLinkedInstitutionsQuery, GetPlaidLinkedInstitutionsQueryVariables>(GetPlaidLinkedInstitutionsDocument, options);
        }
export type GetPlaidLinkedInstitutionsQueryHookResult = ReturnType<typeof useGetPlaidLinkedInstitutionsQuery>;
export type GetPlaidLinkedInstitutionsLazyQueryHookResult = ReturnType<typeof useGetPlaidLinkedInstitutionsLazyQuery>;
export type GetPlaidLinkedInstitutionsQueryResult = Apollo.QueryResult<GetPlaidLinkedInstitutionsQuery, GetPlaidLinkedInstitutionsQueryVariables>;
export const GetPlaidAccessTokenDocument = gql`
    query GetPlaidAccessToken($institutionId: String!, $publicToken: String!) {
  getPlaidAccessToken(institutionId: $institutionId, publicToken: $publicToken) {
    linkedId
    institutionId
    institutionName
    accounts {
      ...PlaidAccount
    }
    source
  }
}
    ${PlaidAccountFragmentDoc}`;

/**
 * __useGetPlaidAccessTokenQuery__
 *
 * To run a query within a React component, call `useGetPlaidAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaidAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaidAccessTokenQuery({
 *   variables: {
 *      institutionId: // value for 'institutionId'
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGetPlaidAccessTokenQuery(baseOptions: Apollo.QueryHookOptions<GetPlaidAccessTokenQuery, GetPlaidAccessTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaidAccessTokenQuery, GetPlaidAccessTokenQueryVariables>(GetPlaidAccessTokenDocument, options);
      }
export function useGetPlaidAccessTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaidAccessTokenQuery, GetPlaidAccessTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaidAccessTokenQuery, GetPlaidAccessTokenQueryVariables>(GetPlaidAccessTokenDocument, options);
        }
export type GetPlaidAccessTokenQueryHookResult = ReturnType<typeof useGetPlaidAccessTokenQuery>;
export type GetPlaidAccessTokenLazyQueryHookResult = ReturnType<typeof useGetPlaidAccessTokenLazyQuery>;
export type GetPlaidAccessTokenQueryResult = Apollo.QueryResult<GetPlaidAccessTokenQuery, GetPlaidAccessTokenQueryVariables>;
export const GetPlaidAccountsDocument = gql`
    query GetPlaidAccounts($accessToken: String!) {
  getPlaidAccounts(accessToken: $accessToken) {
    ...PlaidAccount
  }
}
    ${PlaidAccountFragmentDoc}`;

/**
 * __useGetPlaidAccountsQuery__
 *
 * To run a query within a React component, call `useGetPlaidAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaidAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaidAccountsQuery({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useGetPlaidAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaidAccountsQuery, GetPlaidAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaidAccountsQuery, GetPlaidAccountsQueryVariables>(GetPlaidAccountsDocument, options);
      }
export function useGetPlaidAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaidAccountsQuery, GetPlaidAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaidAccountsQuery, GetPlaidAccountsQueryVariables>(GetPlaidAccountsDocument, options);
        }
export type GetPlaidAccountsQueryHookResult = ReturnType<typeof useGetPlaidAccountsQuery>;
export type GetPlaidAccountsLazyQueryHookResult = ReturnType<typeof useGetPlaidAccountsLazyQuery>;
export type GetPlaidAccountsQueryResult = Apollo.QueryResult<GetPlaidAccountsQuery, GetPlaidAccountsQueryVariables>;
export const GetPlaidInvestmentTransactionsDocument = gql`
    query GetPlaidInvestmentTransactions($accessToken: String!, $startDate: String, $endDate: String, $accounts: [String!]) {
  getPlaidInvestmentTransactions(
    accessToken: $accessToken
    startDate: $startDate
    endDate: $endDate
    accounts: $accounts
  ) {
    accounts {
      ...PlaidAccount
    }
    securities {
      ...PlaidSecurity
    }
    transactions {
      accountId
      amount
      date
      fees
      name
      price
      quantity
      transactionId
      securityId
      subtype
      type
    }
  }
}
    ${PlaidAccountFragmentDoc}
${PlaidSecurityFragmentDoc}`;

/**
 * __useGetPlaidInvestmentTransactionsQuery__
 *
 * To run a query within a React component, call `useGetPlaidInvestmentTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaidInvestmentTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaidInvestmentTransactionsQuery({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      accounts: // value for 'accounts'
 *   },
 * });
 */
export function useGetPlaidInvestmentTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaidInvestmentTransactionsQuery, GetPlaidInvestmentTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaidInvestmentTransactionsQuery, GetPlaidInvestmentTransactionsQueryVariables>(GetPlaidInvestmentTransactionsDocument, options);
      }
export function useGetPlaidInvestmentTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaidInvestmentTransactionsQuery, GetPlaidInvestmentTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaidInvestmentTransactionsQuery, GetPlaidInvestmentTransactionsQueryVariables>(GetPlaidInvestmentTransactionsDocument, options);
        }
export type GetPlaidInvestmentTransactionsQueryHookResult = ReturnType<typeof useGetPlaidInvestmentTransactionsQuery>;
export type GetPlaidInvestmentTransactionsLazyQueryHookResult = ReturnType<typeof useGetPlaidInvestmentTransactionsLazyQuery>;
export type GetPlaidInvestmentTransactionsQueryResult = Apollo.QueryResult<GetPlaidInvestmentTransactionsQuery, GetPlaidInvestmentTransactionsQueryVariables>;
export const GetPlaidTransactionsDocument = gql`
    query GetPlaidTransactions($accessToken: String!, $startDate: String, $endDate: String, $accounts: [String!]) {
  getPlaidTransactions(
    accessToken: $accessToken
    startDate: $startDate
    endDate: $endDate
    accounts: $accounts
  ) {
    accounts {
      ...PlaidAccount
    }
    transactions {
      accountId
      amount
      category
      categoryId
      date
      merchantName
      name
      pending
      transactionId
      transactionType
    }
    value
  }
}
    ${PlaidAccountFragmentDoc}`;

/**
 * __useGetPlaidTransactionsQuery__
 *
 * To run a query within a React component, call `useGetPlaidTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaidTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaidTransactionsQuery({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      accounts: // value for 'accounts'
 *   },
 * });
 */
export function useGetPlaidTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaidTransactionsQuery, GetPlaidTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaidTransactionsQuery, GetPlaidTransactionsQueryVariables>(GetPlaidTransactionsDocument, options);
      }
export function useGetPlaidTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaidTransactionsQuery, GetPlaidTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaidTransactionsQuery, GetPlaidTransactionsQueryVariables>(GetPlaidTransactionsDocument, options);
        }
export type GetPlaidTransactionsQueryHookResult = ReturnType<typeof useGetPlaidTransactionsQuery>;
export type GetPlaidTransactionsLazyQueryHookResult = ReturnType<typeof useGetPlaidTransactionsLazyQuery>;
export type GetPlaidTransactionsQueryResult = Apollo.QueryResult<GetPlaidTransactionsQuery, GetPlaidTransactionsQueryVariables>;
export const GetPlaidHoldingsDocument = gql`
    query GetPlaidHoldings($accessToken: String!) {
  getPlaidHoldings(accessToken: $accessToken) {
    accounts {
      ...PlaidAccount
    }
    securities {
      ...PlaidSecurity
    }
    holdings {
      accountId
      costBasis
      price
      priceDate
      value
      quantity
      securityId
    }
  }
}
    ${PlaidAccountFragmentDoc}
${PlaidSecurityFragmentDoc}`;

/**
 * __useGetPlaidHoldingsQuery__
 *
 * To run a query within a React component, call `useGetPlaidHoldingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaidHoldingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaidHoldingsQuery({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useGetPlaidHoldingsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaidHoldingsQuery, GetPlaidHoldingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaidHoldingsQuery, GetPlaidHoldingsQueryVariables>(GetPlaidHoldingsDocument, options);
      }
export function useGetPlaidHoldingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaidHoldingsQuery, GetPlaidHoldingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaidHoldingsQuery, GetPlaidHoldingsQueryVariables>(GetPlaidHoldingsDocument, options);
        }
export type GetPlaidHoldingsQueryHookResult = ReturnType<typeof useGetPlaidHoldingsQuery>;
export type GetPlaidHoldingsLazyQueryHookResult = ReturnType<typeof useGetPlaidHoldingsLazyQuery>;
export type GetPlaidHoldingsQueryResult = Apollo.QueryResult<GetPlaidHoldingsQuery, GetPlaidHoldingsQueryVariables>;
export const GetCoinbaseDataDocument = gql`
    query GetCoinbaseData($dataType: String!, $account: String) {
  getCoinbaseData(dataType: $dataType, account: $account)
}
    `;

/**
 * __useGetCoinbaseDataQuery__
 *
 * To run a query within a React component, call `useGetCoinbaseDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoinbaseDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoinbaseDataQuery({
 *   variables: {
 *      dataType: // value for 'dataType'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useGetCoinbaseDataQuery(baseOptions: Apollo.QueryHookOptions<GetCoinbaseDataQuery, GetCoinbaseDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoinbaseDataQuery, GetCoinbaseDataQueryVariables>(GetCoinbaseDataDocument, options);
      }
export function useGetCoinbaseDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoinbaseDataQuery, GetCoinbaseDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoinbaseDataQuery, GetCoinbaseDataQueryVariables>(GetCoinbaseDataDocument, options);
        }
export type GetCoinbaseDataQueryHookResult = ReturnType<typeof useGetCoinbaseDataQuery>;
export type GetCoinbaseDataLazyQueryHookResult = ReturnType<typeof useGetCoinbaseDataLazyQuery>;
export type GetCoinbaseDataQueryResult = Apollo.QueryResult<GetCoinbaseDataQuery, GetCoinbaseDataQueryVariables>;
export const GetUserDocument = gql`
    query GetUser {
  getUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const PingDocument = gql`
    query Ping {
  ping
}
    `;

/**
 * __usePingQuery__
 *
 * To run a query within a React component, call `usePingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingQuery({
 *   variables: {
 *   },
 * });
 */
export function usePingQuery(baseOptions?: Apollo.QueryHookOptions<PingQuery, PingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PingQuery, PingQueryVariables>(PingDocument, options);
      }
export function usePingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PingQuery, PingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PingQuery, PingQueryVariables>(PingDocument, options);
        }
export type PingQueryHookResult = ReturnType<typeof usePingQuery>;
export type PingLazyQueryHookResult = ReturnType<typeof usePingLazyQuery>;
export type PingQueryResult = Apollo.QueryResult<PingQuery, PingQueryVariables>;
export const GetStockDocument = gql`
    query GetStock($ticker: String!) {
  getStock(ticker: $ticker) {
    ...StockPrice
  }
}
    ${StockPriceFragmentDoc}`;

/**
 * __useGetStockQuery__
 *
 * To run a query within a React component, call `useGetStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useGetStockQuery(baseOptions: Apollo.QueryHookOptions<GetStockQuery, GetStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockQuery, GetStockQueryVariables>(GetStockDocument, options);
      }
export function useGetStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockQuery, GetStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockQuery, GetStockQueryVariables>(GetStockDocument, options);
        }
export type GetStockQueryHookResult = ReturnType<typeof useGetStockQuery>;
export type GetStockLazyQueryHookResult = ReturnType<typeof useGetStockLazyQuery>;
export type GetStockQueryResult = Apollo.QueryResult<GetStockQuery, GetStockQueryVariables>;
export const GetStockHistoryDocument = gql`
    query GetStockHistory($ticker: String!, $startDate: DateTime!, $endDate: DateTime, $includeAfterHours: Boolean, $frequency: HistoryFrequency) {
  getStockHistory(
    ticker: $ticker
    startDate: $startDate
    endDate: $endDate
    includeAfterHours: $includeAfterHours
    frequency: $frequency
  ) {
    ...StockHistoryPrice
  }
}
    ${StockHistoryPriceFragmentDoc}`;

/**
 * __useGetStockHistoryQuery__
 *
 * To run a query within a React component, call `useGetStockHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockHistoryQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      includeAfterHours: // value for 'includeAfterHours'
 *      frequency: // value for 'frequency'
 *   },
 * });
 */
export function useGetStockHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetStockHistoryQuery, GetStockHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockHistoryQuery, GetStockHistoryQueryVariables>(GetStockHistoryDocument, options);
      }
export function useGetStockHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockHistoryQuery, GetStockHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockHistoryQuery, GetStockHistoryQueryVariables>(GetStockHistoryDocument, options);
        }
export type GetStockHistoryQueryHookResult = ReturnType<typeof useGetStockHistoryQuery>;
export type GetStockHistoryLazyQueryHookResult = ReturnType<typeof useGetStockHistoryLazyQuery>;
export type GetStockHistoryQueryResult = Apollo.QueryResult<GetStockHistoryQuery, GetStockHistoryQueryVariables>;
export const GetStocksDocument = gql`
    query GetStocks($tickers: [String!]!) {
  getStocks(tickers: $tickers) {
    ...StockPrice
  }
}
    ${StockPriceFragmentDoc}`;

/**
 * __useGetStocksQuery__
 *
 * To run a query within a React component, call `useGetStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStocksQuery({
 *   variables: {
 *      tickers: // value for 'tickers'
 *   },
 * });
 */
export function useGetStocksQuery(baseOptions: Apollo.QueryHookOptions<GetStocksQuery, GetStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStocksQuery, GetStocksQueryVariables>(GetStocksDocument, options);
      }
export function useGetStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStocksQuery, GetStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStocksQuery, GetStocksQueryVariables>(GetStocksDocument, options);
        }
export type GetStocksQueryHookResult = ReturnType<typeof useGetStocksQuery>;
export type GetStocksLazyQueryHookResult = ReturnType<typeof useGetStocksLazyQuery>;
export type GetStocksQueryResult = Apollo.QueryResult<GetStocksQuery, GetStocksQueryVariables>;
export const GetStockSearchDocument = gql`
    query GetStockSearch($query: String!) {
  getStockSearch(query: $query) {
    ...StockResult
  }
}
    ${StockResultFragmentDoc}`;

/**
 * __useGetStockSearchQuery__
 *
 * To run a query within a React component, call `useGetStockSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetStockSearchQuery(baseOptions: Apollo.QueryHookOptions<GetStockSearchQuery, GetStockSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockSearchQuery, GetStockSearchQueryVariables>(GetStockSearchDocument, options);
      }
export function useGetStockSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockSearchQuery, GetStockSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockSearchQuery, GetStockSearchQueryVariables>(GetStockSearchDocument, options);
        }
export type GetStockSearchQueryHookResult = ReturnType<typeof useGetStockSearchQuery>;
export type GetStockSearchLazyQueryHookResult = ReturnType<typeof useGetStockSearchLazyQuery>;
export type GetStockSearchQueryResult = Apollo.QueryResult<GetStockSearchQuery, GetStockSearchQueryVariables>;
export const GetStockDetailsDocument = gql`
    query GetStockDetails($ticker: String!) {
  getStockDetails(ticker: $ticker) {
    ...StockDetails
  }
}
    ${StockDetailsFragmentDoc}`;

/**
 * __useGetStockDetailsQuery__
 *
 * To run a query within a React component, call `useGetStockDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockDetailsQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useGetStockDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetStockDetailsQuery, GetStockDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockDetailsQuery, GetStockDetailsQueryVariables>(GetStockDetailsDocument, options);
      }
export function useGetStockDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockDetailsQuery, GetStockDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockDetailsQuery, GetStockDetailsQueryVariables>(GetStockDetailsDocument, options);
        }
export type GetStockDetailsQueryHookResult = ReturnType<typeof useGetStockDetailsQuery>;
export type GetStockDetailsLazyQueryHookResult = ReturnType<typeof useGetStockDetailsLazyQuery>;
export type GetStockDetailsQueryResult = Apollo.QueryResult<GetStockDetailsQuery, GetStockDetailsQueryVariables>;
export const GetFetchDocument = gql`
    query GetFetch($command: String!, $token: String!, $destination: FetchDestination) {
  getFetch(command: $command, token: $token, destination: $destination)
}
    `;

/**
 * __useGetFetchQuery__
 *
 * To run a query within a React component, call `useGetFetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFetchQuery({
 *   variables: {
 *      command: // value for 'command'
 *      token: // value for 'token'
 *      destination: // value for 'destination'
 *   },
 * });
 */
export function useGetFetchQuery(baseOptions: Apollo.QueryHookOptions<GetFetchQuery, GetFetchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFetchQuery, GetFetchQueryVariables>(GetFetchDocument, options);
      }
export function useGetFetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFetchQuery, GetFetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFetchQuery, GetFetchQueryVariables>(GetFetchDocument, options);
        }
export type GetFetchQueryHookResult = ReturnType<typeof useGetFetchQuery>;
export type GetFetchLazyQueryHookResult = ReturnType<typeof useGetFetchLazyQuery>;
export type GetFetchQueryResult = Apollo.QueryResult<GetFetchQuery, GetFetchQueryVariables>;
export const GetFilesDocument = gql`
    query GetFiles {
  getFiles {
    ...File
  }
}
    ${FileFragmentDoc}`;

/**
 * __useGetFilesQuery__
 *
 * To run a query within a React component, call `useGetFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetFilesQuery, GetFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
      }
export function useGetFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesQuery, GetFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
        }
export type GetFilesQueryHookResult = ReturnType<typeof useGetFilesQuery>;
export type GetFilesLazyQueryHookResult = ReturnType<typeof useGetFilesLazyQuery>;
export type GetFilesQueryResult = Apollo.QueryResult<GetFilesQuery, GetFilesQueryVariables>;
export const GetRefreshedFilesDocument = gql`
    query GetRefreshedFiles($uuids: [ID!]!) {
  getRefreshedFiles(uuids: $uuids) {
    ...File
  }
}
    ${FileFragmentDoc}`;

/**
 * __useGetRefreshedFilesQuery__
 *
 * To run a query within a React component, call `useGetRefreshedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefreshedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefreshedFilesQuery({
 *   variables: {
 *      uuids: // value for 'uuids'
 *   },
 * });
 */
export function useGetRefreshedFilesQuery(baseOptions: Apollo.QueryHookOptions<GetRefreshedFilesQuery, GetRefreshedFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefreshedFilesQuery, GetRefreshedFilesQueryVariables>(GetRefreshedFilesDocument, options);
      }
export function useGetRefreshedFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefreshedFilesQuery, GetRefreshedFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefreshedFilesQuery, GetRefreshedFilesQueryVariables>(GetRefreshedFilesDocument, options);
        }
export type GetRefreshedFilesQueryHookResult = ReturnType<typeof useGetRefreshedFilesQuery>;
export type GetRefreshedFilesLazyQueryHookResult = ReturnType<typeof useGetRefreshedFilesLazyQuery>;
export type GetRefreshedFilesQueryResult = Apollo.QueryResult<GetRefreshedFilesQuery, GetRefreshedFilesQueryVariables>;
export const GetFriendsDocument = gql`
    query GetFriends {
  getFriends {
    ...Friend
  }
}
    ${FriendFragmentDoc}`;

/**
 * __useGetFriendsQuery__
 *
 * To run a query within a React component, call `useGetFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFriendsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFriendsQuery(baseOptions?: Apollo.QueryHookOptions<GetFriendsQuery, GetFriendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFriendsQuery, GetFriendsQueryVariables>(GetFriendsDocument, options);
      }
export function useGetFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFriendsQuery, GetFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFriendsQuery, GetFriendsQueryVariables>(GetFriendsDocument, options);
        }
export type GetFriendsQueryHookResult = ReturnType<typeof useGetFriendsQuery>;
export type GetFriendsLazyQueryHookResult = ReturnType<typeof useGetFriendsLazyQuery>;
export type GetFriendsQueryResult = Apollo.QueryResult<GetFriendsQuery, GetFriendsQueryVariables>;